<template>
  <div class="tw-w-full tw-flex tw-flex-col tw-gap-3">
    <div class="tw-flex tw-items-end tw-gap-2 tw-text-xl tw-font-bold">
      <span class="tw-text-[#F1583D]">1.</span> 
      <span>Current Portfolio(s)</span>
      <span class="tw-text-sm tw-italic tw-font-normal">(optional)</span>
    </div>
    
    <!-- Changed this container to align items at the start -->
    <div class="tw-flex tw-items-start tw-gap-2">
      <PortfolioSearchSelect
        placeholder="Search for portfolios"
        @selected="handleSelected"
      />
      <!-- Add a container for Upload PDF button + checkbox -->
      <div class="tw-flex tw-flex-col tw-gap-2">
        <UploadNewButton />
      </div>
      <UploadCsvButton />
    </div>
    
    <PortfolioUploadOverview />
    <AdvisorCoreNotifications v-if="checkupStore.hasNotifications || checkupStore.uploadFailedFiles?.length || checkupStore.uploadInvalidFiles?.length" />
    <SelectedPortfolios
      :portfolios="checkupStore.selectedPortfolios"
      @remove="handleRemove"
      :showTaxabilityDropdown="false" 
    />
    <SpreadsheetLinks />
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import PortfolioSearchSelect from './PortfolioSearchSelect.vue';
import UploadNewButton from './UploadNewButton.vue';
import SelectedPortfolios from './SelectedPortfolios.vue';
import PortfolioUploadOverview from './PortfolioUploadOverview.vue';
import SpreadsheetLinks from './SpreadsheetLinks.vue';
import AdvisorCoreNotifications from '@frontend/ui/features/checkup/components/AdvisorCoreNotifications.vue';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
import { mapStores } from 'pinia';
import UploadCsvButton from './UploadCsvButton.vue';


export default {
  name: 'PortfolioSelectWrapper',
  components: { PortfolioSearchSelect, UploadNewButton, UploadCsvButton, SelectedPortfolios, PortfolioUploadOverview, AdvisorCoreNotifications, SpreadsheetLinks },
  props: {
    // prop: { type: String, required: true },
    // prop: String,
  },
  data() {
    return { selectedPortfolios: [] };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    ...mapStores(useCheckupStore),

  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    handleSelected(portfolio) {
      this.checkupStore.portfolios = [...this.checkupStore.portfolios, { ...portfolio, label: 'portfolio', isChecked: true }];
      // this.checkupStore.addPortfolio(portfolio);
    },
    handleRemove(portfolio) {
      this.checkupStore.portfolios = this.checkupStore.portfolios.filter(p => p.external_id !== portfolio.external_id);
    },
  },
};
</script>


<style scoped>

</style>
